var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56",
  transform: "translate(-0.256 -0.181)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 40,
  height: 40,
  rx: 20,
  transform: "translate(0.256 0.181)",
  fill: "#008c45"
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-logo-youtube",
  "data-name": "Icon ionic-logo-youtube",
  d: "M21.19,8.033A3.239,3.239,0,0,0,18.107,4.65c-2.308-.108-4.662-.15-7.066-.15h-.75c-2.4,0-4.758.042-7.066.15A3.246,3.246,0,0,0,.146,8.041C.041,9.525,0,11.008,0,12.491s.042,2.966.142,4.454a3.25,3.25,0,0,0,3.079,3.4c2.425.112,4.912.162,7.441.158s5.012-.042,7.441-.158a3.25,3.25,0,0,0,3.083-3.4c.1-1.487.146-2.971.142-4.458S21.29,9.521,21.19,8.033ZM8.624,16.578V8.391l6.041,4.091Z",
  transform: "translate(9.256 7.681)",
  fill: "#fff"
}));
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ea7c307e62496bfab76243af17971417.svg";
export { ForwardRef as ReactComponent };